import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { FavoritesProvider } from './hooks/useFavorites'
import { I18nProvider } from './i18n/I18nContext'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nProvider>
      <FavoritesProvider>
        <App />
      </FavoritesProvider>
    </I18nProvider>
  </React.StrictMode>,
)